module.exports = new __parcel__URL__("hope.b28c9560.png").toString();